import { faAngleDown, faAngleUp, faEnvelope, faPen, faPrint, faThumbsUp, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";

function ActionDropdown({ options, onClickHandle, item, isEditButtonDisable, isDeleteButtonDisable, isEmailButtonDisable, isApproveButtonDisable }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative action-dropdown w-full" ref={dropdownRef}>
      <div className="dropdown-top flex justify-between items-center px-3.5 py-1.5 cursor-pointer w-full border border-gray-300 rounded-md bg-white" onClick={toggleDropdown}>
        Select action <FontAwesomeIcon className="w-[14px] h-[14px] p-[4px] bg-[#77bfca] rounded-[50px] text-white" icon={isOpen ? faAngleUp : faAngleDown} />
      </div>
      {isOpen && (
        <div className="absolute left-0 mt-1 bg-white border border-gray-300 shadow-lg rounded-md grid w-full z-10">
          {options.includes('edit') && (
            <p
              onClick={() => onClickHandle('edit', item)}
              className={`${isEditButtonDisable ? 'pointer-events-none opacity-50' : ''} flex flex-row-reverse items-center font-medium justify-between px-3.5 py-1.5 m-0 cursor-pointer hover:bg-blue-100 text-blue-600`}>
              <FontAwesomeIcon className="w-[12px] h-[12px] p-[5px] bg-blue-600 text-white rounded-[50px]"
                icon={faPen} />
              Edit
            </p>
          )}
          {options.includes('delete') && (
            <p
              onClick={() => onClickHandle('delete', item)}
              className={`${isDeleteButtonDisable ? 'pointer-events-none opacity-50' : ''} flex flex-row-reverse items-center font-medium justify-between px-3.5 py-1.5 m-0 cursor-pointer hover:bg-red-100 text-red-600`}>
              <FontAwesomeIcon className="w-[12px] h-[12px] p-[5px] bg-red-600 text-white rounded-[50px]"
                icon={faTrash} />
              Delete
            </p>
          )}
          {options.includes('sendEmail') && (
            <p
              onClick={() => onClickHandle('sendEmail', item)}
              className={`${isEmailButtonDisable ? 'pointer-events-none opacity-50' : ''} flex flex-row-reverse items-center font-medium justify-between px-3.5 py-1.5 m-0 cursor-pointer hover:bg-orange-100 text-orange-600`}>
              <FontAwesomeIcon className="w-[12px] h-[12px] p-[5px] bg-orange-600 text-white rounded-[50px]"
                icon={faEnvelope} />
              Send email
            </p>
          )}
          {/* {options.includes('print') && (
            <p onClick={() => onClickHandle('print', item)} className="flex flex-row-reverse items-center font-medium justify-between px-3.5 py-1.5 m-0 cursor-pointer hover:bg-[rgba(119,191,202,0.3)] text-[#1b6c79]"><FontAwesomeIcon className="w-[12px] h-[12px] p-[5px] bg-[#1b6c79] text-white rounded-[50px]" icon={faPrint} />Print</p>
          )} */}
          {options.includes('approveOrder') && (
            <p
              onClick={() => onClickHandle('approveOrder', item)}
              className={`${isApproveButtonDisable ? 'pointer-events-none opacity-50' : ''} flex flex-row-reverse items-center font-medium justify-between px-3.5 py-1.5 m-0 cursor-pointer hover:bg-green-100 text-green-600`}>
              <FontAwesomeIcon className="w-[12px] h-[12px] p-[5px] bg-green-600 text-white rounded-[50px]"
                icon={faThumbsUp} />
              Approve order
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default ActionDropdown;
